import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { ProxmoxFormModel } from 'wizards/models/proxmox/proxmox-form-model';
import { BaseForVMPlanHelper } from '../bases/base-for-vm-plan-helper';

export class ProxmoxPlanFromStepsHelper extends BaseForVMPlanHelper {
  public static ProxmoxModel: ProxmoxFormModel = null;

  public static getUpdatedPlan(plan, model: ProxmoxFormModel, settings: WizardHelpersSettings): any {
    this.ProxmoxModel = model;
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);
    return newPlan;
  }

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    this.isNBF = settings.isNBF;
    this.isNBFWithHybrid = settings.isNBF && this.canHybridOnNbf(settings.agentVersion);

    PlanDataFromStepsHelper.updateNewPlanByNameStep(newPlan, this.ProxmoxModel.planNameStep);

    if (this.isNBFWithHybrid) {
      PlanDataFromStepsHelper.updateNewPlanNBFHybridByWhereBackupStep(newPlan, this.ProxmoxModel.whereBackupStep, this.isUnix);
    } else PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(newPlan, this.ProxmoxModel.whereBackupStep, this.isNBF || this.isUnix);

    PlanDataFromStepsHelper.updateNewPlanBySelectHostStep(newPlan, this.ProxmoxModel.selectHostStep);
    PlanDataFromStepsHelper.updateNewPlanBySelectVirtualMachineStep(newPlan, this.ProxmoxModel.selectVirtualMachinesStep, true);
    PlanDataFromStepsHelper.updateNewPlanByVirtualAdvancedSettings(
      newPlan,
      this.ProxmoxModel.advancedSettingsStep,
      false,
      false,
      this.isNBF
    );

    PlanDataFromStepsHelper.updateNewPlanArchiveByArchiveConsistencyStep(newPlan, this.ProxmoxModel.archiveConsistencyStep);
    PlanDataFromStepsHelper.updateNewNBFPlanByScheduleStep(newPlan, this.ProxmoxModel.scheduleStep);
    PlanDataFromStepsHelper.updateNewNBFPlanByRetentionPolicyStep(newPlan, this.ProxmoxModel.retentionPolicyStep, true);

    if (this.isNBFWithHybrid) {
      PlanDataFromStepsHelper.updateNewNBFPlanWithHybridByRetentionPolicyStep(newPlan, this.ProxmoxModel.retentionPolicyStep);
    }

    PlanDataFromStepsHelper.updateNewPlanByCompressionEncryptionStep(newPlan, this.ProxmoxModel.compressionEncryptionStep, this.isNBF);
    PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(newPlan, this.ProxmoxModel.prePostActionsStep, !settings.allowPrePostActions);
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.ProxmoxModel.notificationStep, this.isUnix);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan, false);
  }
}
